import { makeStyles } from '@mui/styles';
import Typography from 'apollo-react/components/Typography';
import classNames from 'classnames';
import React from 'react';

import { useTranslation } from '../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  fieldContainer: {
    display: 'flex',
    width: 750,
    alignItems: 'center',
    '@media (max-width: 480px)': {
      flexDirection: 'column',
      width: '100%',
      paddingRight: 10,
      alignItems: 'normal',
    },
  },
  viewOnlyFieldContainer: {
    margin: '5px 0px',
  },
  rowLabel: {
    width: 200,
    paddingTop: 8,
    marginRight: 20,
    alignItems: 'center',
  },
  field: {
    margin: 0,
    flex: 1,
  },
  viewOnlyField: {
    paddingTop: 8,
  },
});

const RowField = ({ rowLabel, isViewOnly, viewOnlyValue, children }) => {
  const translateString = useTranslation();
  const classes = useStyles();

  const viewOnlyValueToDisplay = viewOnlyValue || '---';

  return (
    <div
      className={classNames({
        [classes.fieldContainer]: true,
        [classes.viewOnlyFieldContainer]: isViewOnly,
      })}
    >
      <div className={classes.rowLabel}>
        <Typography>{translateString(rowLabel)}</Typography>
      </div>
      {isViewOnly ? (
        <Typography className={classNames(classes.viewOnlyField, classes.field)}>
          {viewOnlyValueToDisplay}
        </Typography>
      ) : (
        children
      )}
    </div>
  );
};

export default RowField;
